module.exports = __webpack_public_path__ + "img/特堤_入口網頁_橫式_01.7cd8d646.webp";